// project import
import dashboard from './dashboard';
import sectors from './sectors';
import administration from './administration';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, administration, sectors]
};

export default menuItems;
